import { render, staticRenderFns } from "./RechargeDialog.vue?vue&type=template&id=596fb2e6&lang=pug&"
import script from "./RechargeDialog.vue?vue&type=script&lang=ts&"
export * from "./RechargeDialog.vue?vue&type=script&lang=ts&"
import style0 from "./RechargeDialog.vue?vue&type=style&index=0&id=596fb2e6&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports